"use client";

import { useEffect } from "react";
import { toast } from "sonner";
import { popFlashToast } from "@/app/lib/flashToast";

export default function FlashToast() {
  useEffect(() => {
    const flash = popFlashToast();
    if (!flash) return;
    const show = () => toast[flash.type](flash.message);
    // küçük gecikme: Toaster mount'tan sonra garantili çalışsın
    const t = setTimeout(show, 100);
    return () => clearTimeout(t);
  }, []);

  return null;
}